// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_footer {
    bottom: 0;
    padding: 10px 20px;
    background-color: #0E0A40;
    width: 100%;
}

.dashboard_footer_top_container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.dashboard_footer_bottom_text {
    font-size: 12px;
    margin-bottom: 20px;
    color: #6b6b6b;
}

.dashboard_footer_top_box {
    display: flex;
    flex-direction: column;
}

.dashboard_footer_top_container > div > h3 {
    color: #FFFFFF;
    margin-bottom: 5px;
    line-height: 20px;
}

.dashboard_footer_top_box > a {
    margin-top: 0;
    margin-bottom: 3px;
    font-size: 11px;
    color: #FFFFFF;
    text-decoration: none;
}

.footer_download_btn {
    height: 34px;
    margin-right: 20px;
}

.dashboard_footer_bottom_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0px;
    color: #6b6b6b;
    font-size: 11px;
}

.dashboard_footer_bottom_box > .row > a {
    color: #6b6b6b;
    text-decoration: none;
    transition: 0.3s;
}

.dashboard_footer_bottom_box > .row > a:hover {
    color: #ffffff;
}

.dashboard_footer_bottom_box > .row > a:not(:last-child) {
    padding-right: 5px;
    border-right: 1px solid #6b6b6b;
    margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Footer/styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;AACrB","sourcesContent":[".dashboard_footer {\n    bottom: 0;\n    padding: 10px 20px;\n    background-color: #0E0A40;\n    width: 100%;\n}\n\n.dashboard_footer_top_container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.dashboard_footer_bottom_text {\n    font-size: 12px;\n    margin-bottom: 20px;\n    color: #6b6b6b;\n}\n\n.dashboard_footer_top_box {\n    display: flex;\n    flex-direction: column;\n}\n\n.dashboard_footer_top_container > div > h3 {\n    color: #FFFFFF;\n    margin-bottom: 5px;\n    line-height: 20px;\n}\n\n.dashboard_footer_top_box > a {\n    margin-top: 0;\n    margin-bottom: 3px;\n    font-size: 11px;\n    color: #FFFFFF;\n    text-decoration: none;\n}\n\n.footer_download_btn {\n    height: 34px;\n    margin-right: 20px;\n}\n\n.dashboard_footer_bottom_box {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 0px;\n    color: #6b6b6b;\n    font-size: 11px;\n}\n\n.dashboard_footer_bottom_box > .row > a {\n    color: #6b6b6b;\n    text-decoration: none;\n    transition: 0.3s;\n}\n\n.dashboard_footer_bottom_box > .row > a:hover {\n    color: #ffffff;\n}\n\n.dashboard_footer_bottom_box > .row > a:not(:last-child) {\n    padding-right: 5px;\n    border-right: 1px solid #6b6b6b;\n    margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
